import React, { useEffect, useRef } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { allsvg } from '../../utils/allsvg.js';
import './OldNavbar.scss';
import about from '../../assets/img/menu-about.jpg';
import dusk from '../../assets/img/dusk.jpg';
import play from '../../assets/img/menu-play.jpg';
import community from '../../assets/img/menu-community.jpg';
import { useUser } from '../../hooks/useUser';
import { routes } from '../../routing/routes';
import { persistentCookie } from '../../utils/cookie';
import { StatefulAnnouncement } from '../Announcement/StatefulAnnouncement';
import { FeatureFlagged } from '../FeatureFlagged/FeatureFlagged';
import { FLAGS } from '../../hooks/useFlags';

export default function OldNavbar() {
  const location = useLocation();

  const navbarRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // This is a hack to ensure that the main dropdown nav is closed when
    // changing locations on mobile. See DBM-836 for more details
    navbarRef.current?.classList?.remove('show');

    const offcanvasBackdrop = document.querySelector('.offcanvas-backdrop');
    // The backdrop does not close manually on mobile, so we have to do it
    // manually here. We do not have access to the bootstrap global object
    // so we must manually click the dusknav to dismiss it.
    if (offcanvasBackdrop && offcanvasBackdrop.classList.contains('show')) {
      const navButton = document.querySelector('button[data-bs-target="#dusknav"]');
      if (navButton) {
        (navButton as HTMLButtonElement).click();
      }
    }
  }, [location]);

  const navWrapperRef = useRef<HTMLBaseElement>(null);
  useEffect(() => {
    const onScroll = () => {
      const position = window.scrollY;

      if (position > 60) {
        navWrapperRef.current?.classList?.add('opaque');
      } else {
        navWrapperRef.current?.classList?.remove('opaque');
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [navWrapperRef]);

  const { playfab } = useUser();

  const navabout = {
    background: 'url(' + about + ') no-repeat center center',
    backgroundSize: 'cover',
  };
  const navstory = {
    background: 'url(' + dusk + ') no-repeat 84%',
  };
  const navplay = {
    background: 'url(' + play + ') no-repeat center center',
    backgroundSize: 'cover',
  };
  const navcommunity = {
    background: 'url(' + community + ') no-repeat center center',
    backgroundSize: 'cover',
  };

  return (
    <header id="nav-header">
      <a aria-hidden="true" id="top" className="visually-hidden">
        Top of of the page
      </a>
      <nav className="navbar navbar-expand-lg navbar-dark fixed-top" ref={navWrapperRef}>
        <SurveyAnnouncement />
        <div className="container-fluid" id="container-allwrap">
          <Link className="navbar-brand" id="topbar-logo" to={routes.home()}>
            <SVG src={allsvg.textlogo} />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#dusknav"
            aria-controls="dusknav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="offcanvas offcanvas-end" ref={navbarRef} id="dusknav" tabIndex={-1}>
            <div className="offcanvas-header py-3 m-0">
              <h5 className="offcanvas-title" id="offcanvasLabel">
                Main Menu
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body p-0">
              <ul className="navbar-nav ms-lg-auto">
                <li className="nav-item">
                  <Link className="nav-link" to={routes.mint()}>
                    Mint&nbsp;<span className="badge menu-badge">NEW</span>
                  </Link>
                </li>
                {/* ======================== About Megamenu */}
                <li className="nav-item dropdown has-megamenu">
                  <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    About
                  </button>
                  <div className="dropdown-menu megamenu fade" role="menu">
                    <div className="container ml-auto mr-">
                      <div className="row g-0 d-flex align-items-stretch">
                        <div className="mega-wrap">
                          <div className="col-lg-4 d-none d-lg-block">
                            <div className="p-3 pb-0 p-lg-4 h-100">
                              <p className="text-large">Learn About Us</p>
                              <p className="text-small">
                                DuskBreakers is a sci-fi inspired metaverse and gaming experience
                                powered by blockchain.
                              </p>
                              <p className="text-small">
                                Join a select squad of Breakers who spend their days exploring a
                                mysterious alien spaceship filled with friends, foes, and
                                otherworldly technology.
                              </p>
                            </div>
                          </div>

                          <div className="col-lg-4 has-bg">
                            <div className="is-bg" style={navabout} />
                          </div>

                          <div className="col-lg-4">
                            <div className="p-0 p-lg-4 h-100">
                              <ul className="nav flex-column">
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.roadmap()}>
                                    Roadmap
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.news.base()}>
                                    News
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.faq()}>
                                    FAQs
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.team()}>
                                    Team
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://jobs.lever.co/Metatheory/"
                                    target="_new"
                                  >
                                    Careers
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.provenance()}>
                                    Provenance
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.help()}>
                                    Help
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                {/* ======================== Close About Megamenu */}
                {/* ======================== Story Megamenu */}
                <li className="nav-item dropdown has-megamenu">
                  <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    Story
                  </button>
                  <div className="dropdown-menu megamenu" role="menu">
                    <div className="container">
                      <div className="row g-0 d-flex align-items-stretch">
                        <div className="mega-wrap">
                          <div className="col-lg-4 d-none d-lg-block">
                            <div className="p-3 pb-0 p-lg-4 h-100">
                              <p className="text-large">Explore the Story</p>
                              <p className="text-small">
                                From the Dusk and her alien creatures to the city of Machafuko and
                                the heroic Breakers who will change our fate, we welcome you to
                                explore the world of DuskBreakers.
                              </p>
                            </div>
                          </div>

                          <div className="col-lg-4 has-bg">
                            <div className="is-bg" style={navstory} />
                          </div>

                          <div className="col-lg-4">
                            <div className="p-0 p-lg-4 h-100">
                              <ul className="nav flex-column">
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.comic.base()}>
                                    Webcomic
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.lore.base()}>
                                    Lore
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.media()}>
                                    Media
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                {/* ======================== Close Story Megamenu */}
                <li className="nav-item">
                  <Link className="nav-link" to={routes.gallery.base()}>
                    Gallery
                  </Link>
                </li>
                {/* ======================== Community Megamenu */}
                <li className="nav-item dropdown has-megamenu">
                  <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    Community
                  </button>
                  <div className="dropdown-menu megamenu" role="menu">
                    <div className="container">
                      <div className="row g-0 d-flex align-items-stretch">
                        <div className="mega-wrap">
                          <div className="col-lg-4 d-none d-lg-block">
                            <div className="p-3 pb-0 p-lg-4 h-100">
                              <p className="text-large">Become a Breaker</p>
                              <p className="text-small">
                                Join your fellow Breakers for community events, giveaways,
                                discussions, AMAs, and game updates on our Discord server, or watch
                                DuskBreakers content across our social media channels!
                              </p>
                            </div>
                          </div>

                          <div className="col-lg-4 has-bg">
                            <div className="is-bg" style={navcommunity} />
                          </div>

                          <div className="col-lg-4">
                            <div className="p-0 p-lg-4 h-100">
                              <ul className="nav flex-column">
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://discord.gg/duskbreakers"
                                    target="_new"
                                  >
                                    <SVG className="ui-icon faded" src={allsvg.discord_icon} />
                                    <span>Discord</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://twitter.com/duskbreakers"
                                    target="_new"
                                  >
                                    <SVG className="ui-icon faded" src={allsvg.twitter_icon} />
                                    <span>Twitter</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://opensea.io/collection/duskbreakers"
                                    target="_new"
                                  >
                                    <SVG className="ui-icon faded" src={allsvg.opensea_icon} />
                                    <span>OpenSea</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://www.instagram.com/DuskBreakersNFT/"
                                    target="_new"
                                  >
                                    <SVG className="ui-icon faded" src={allsvg.instagram_icon} />
                                    <span>Instagram</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://www.youtube.com/channel/UCnAWj3_CYl30cga1k5fzG9g"
                                    target="_new"
                                  >
                                    <SVG className="ui-icon faded" src={allsvg.youtube_icon} />
                                    <span>Youtube</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://www.twitch.tv/duskbreakers"
                                    target="_new"
                                  >
                                    <SVG className="ui-icon faded" src={allsvg.twitch_icon} />
                                    <span>Twitch</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    href="https://www.tiktok.com/@duskbreakers"
                                    target="_new"
                                  >
                                    <SVG className="ui-icon faded" src={allsvg.tiktok_icon} />
                                    <span>TikTok</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                {/* ======================== Close Community Megamenu */}

                <li className="nav-item dropdown has-megamenu">
                  <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    Play Now
                  </button>
                  <div className="dropdown-menu megamenu" role="menu">
                    <div className="container">
                      <div className="row g-0 d-flex align-items-stretch">
                        <div className="mega-wrap">
                          <div className="col-lg-4 d-none d-lg-block">
                            <div className="p-3 pb-0 p-lg-4 h-100">
                              <p className="text-large">Always Free to Play</p>
                              <p className="text-small">
                                Try one of our minigame experiences on our Windows Launcher or right
                                here in your browser! You do not need a DuskBreakers NFT to play,
                                but you will be asked to connect a wallet and create a Breaker ID
                                login to begin. Can you top the leaderboards?
                              </p>
                            </div>
                          </div>

                          <div className="col-lg-4 has-bg">
                            <div className="is-bg" style={navplay} />
                          </div>

                          <div className="col-lg-4">
                            <div className="p-0 p-lg-4 h-100">
                              <ul className="nav flex-column">
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.launcher()}>
                                    Download Launcher
                                  </Link>
                                </li>
                                {playfab.isConnected ? (
                                  <li className="nav-item">
                                    <Link className="nav-link" to={routes.duskAccount.base()}>
                                      DuskBreakers Account
                                    </Link>
                                  </li>
                                ) : (
                                  <li className="nav-item">
                                    <Link className="nav-link" to={routes.login()}>
                                      Login
                                    </Link>
                                  </li>
                                )}
                                <li className="nav-item">
                                  <Link className="nav-link" to={routes.playToMint()}>
                                    Play to Mint
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

function SurveyAnnouncement() {
  return (
    <FeatureFlagged
      flag={FLAGS.duskbreakersSurvey}
      spinner={null}
      fallbackStrategy={{ type: 'ignore' }}
    >
      <StatefulAnnouncement
        announcement={{
          actionButtonText: 'Take the Survey',
          actionButtonLink: new URL(
            'https://docs.google.com/forms/d/e/1FAIpQLSfvrLZAZRyhZNpy6LwZPflsxIvMP2T03wJy5pa3QyVrChRb7A/viewform',
          ),
        }}
        cookie={persistentCookie.duskBreakersSurvey}
      >
        We’d like your feedback to make your DuskBreakers experience better!
      </StatefulAnnouncement>
    </FeatureFlagged>
  );
}
